export const FinanceType = {
  EXPENSE: "expense",
  INCOME: "income",
} as const;

export type FinanceTypeDef = (typeof FinanceType)[keyof typeof FinanceType];
